import { SearchQuery } from '@mainstage/plugin-search-common';
import { JsonObject } from '@mainstage/types';
import { OrderByOption } from './OrderByOption';
import { BUSINESS_CONCEPTS_PATH } from '../collators';

// TODO this includes only fields relevant for marketplace search but many are only for MARKETPLACE_PROJECTS collator,
// improve this to account for PROVISIONING_CONSUMABLES as well
export const ALLOWED_SEARCH_SELECTION_FIELDS = [
  'type',
  'external_id',
  'document',
  'document.documentId',
  'document._computedInfo',
  'document.useCaseTemplateId',
  'document.taxonomy_id',
  'document.kind',
  `document.${BUSINESS_CONCEPTS_PATH}`,
] as const;

export type AllowedSearchSelectionField =
  (typeof ALLOWED_SEARCH_SELECTION_FIELDS)[number];

export interface WitboostSearchQuery extends SearchQuery {
  useHighlight?: boolean;
  orderBy?: OrderByOption;
  select?: AllowedSearchSelectionField[];
}

export interface SearchFilterValuesQuery {
  currentFilters?: JsonObject;
  queryTerm?: string;
}
